import '../../App.less';
import {  Layout, Row, Col,ConfigProvider,  Card} from 'antd';
import React, { Component } from "react";
import 'react-phone-input-2/lib/style.css'
import es_ES from 'antd/lib/locale/es_ES';
import {IP} from '../components/utils';
import Foot from "../components/Footer"
import AdminMenu from "../components/AdminMenu"
class BasesAdmin extends Component {
  async componentDidMount() {
    const response = await fetch(IP + 'api/casa/genero/');//To check if it is logued. If returns datail key, is not logued
    const json = await response.json();
    if(json['detail']){
      localStorage.clear()
      window.location.reload(); 
    }
  }
  render() {
    const { Content } = Layout;
    return (
    <div className="page-container">
      <div className = "content-wrap">
        <ConfigProvider locale={es_ES}>
          <Layout style={{backgroundColor:'white'}}>
          <AdminMenu defaultSelectedKey={"home"} />
            <div style={{flexDirection:'column', flex:'1 0 auto', display:'flex'}} >
              <Row >
                <Col span={24} >
                  <Content style={{ padding: '0 50px' }}>
                    <Card title=" Bases Premio Literario Casa de las Américas " bordered={false}  >
                    <p>Del 22 al 26 de abril de 2024<br/>

La Casa de las Américas convoca para el año 2024 a la edición 64 de su Premio Literario. En esta ocasión podrán concursar obras inéditas en a) <b>novela</b>, b) <b>ensayo de tema artístico-literario</b>, c) <b>teatro</b> y d) <b>literatura para niños y jóvenes</b>.
Los concursantes deberán regirse por las siguientes


                   <ol style={{paddingLeft:'1.8em'}}>
                     <li>Podrán enviarse obras inéditas en español en <b>novela</b>, <b>ensayo de tema artístico-literario</b>, <b>teatro</b> y <b>literatura para niños y jóvenes.</b>. Se considerarán inéditas aun aquellas que hayan sido impresas en no más de la mitad.</li>
                    <li>En <b>novela</b>, <b>teatro</b> y <b>literatura para niños y jóvenes.</b> solo podrán participar autores latinoamericanos, naturales o naturalizados. </li>
                    <li>Por el premio de <b>ensayo de tema artístico-literario</b> podrán concursar también autores de cualquier otra procedencia, con un libro sobre la América Latina o el Caribe. </li>
                    <li>Ningún autor podrá enviar más de un libro por género, ni participar con una obra en proceso de impresión, aunque esté inédita, o que haya obtenido algún premio nacional o internacional u opte por él mientras no se haya dado el fallo del Premio Casa de las Américas. Tampoco podrá participar en un género en el que hubiera obtenido ya este Premio, en alguno de los cinco años anteriores.</li>
                    <li>Se otorgará un premio único e indivisible por cada género que consistirá en 3000 dólares o su equivalente en la moneda nacional que corresponda, y la publicación de la obra por la Casa de las Américas. Se otorgarán menciones si el jurado las estima necesarias, sin que ello implique retribución ni compromiso editorial por parte de la Casa de las Américas.</li>
                    <li>Las obras serán firmadas con seudónimo. </li>
                    <li>La Casa de las Américas se reserva el derecho de publicación, tanto en formato impreso como digital, de la que será considerada primera edición de las obras premiadas. En el primer caso, los derechos de publicación cubren hasta un máximo de 10 000 ejemplares, aunque se trate de una coedición o de reimpresiones coeditadas. Tal derecho incluye no solo evidentes aspectos económicos sino todas las características gráficas y otras de la mencionada primera edición.</li>
                    <li>Los autores deberán enviar sus obras de manera digital, en pdf, accediendo a <a href='https://premiocasa.cu/casa/registro'>https://premiocasa.cu/casa/registro</a> a partir del 1º de octubre del año en curso. Las obras no excederán en ningún caso de las quinientas (500) páginas (escritas en Times New Roman 12, a espacio y medio).</li>
                    <li>El plazo de admisión cerrará el 31 de enero de 2024 a las 12 de la noche, hora de Cuba.</li>
                    <li>Los premios se darán a conocer el 26 de abril de 2024.</li>
                    <li>El incumplimiento de alguna de estas bases conduciría a la invalidación del Premio otorgado.</li>
                   </ol> 
                 </p>
                    </Card>
                  </Content>
                </Col>
              </Row>
            </div>
          </Layout>
        </ConfigProvider>
      </div>
      <Foot admin={true}/>
    </div>

    );
  }
}
export default BasesAdmin;


